<div class="app-main-container">
  <div class="background"></div>
  <the-header></the-header>
  <div class="app-content-container">
    <router-outlet></router-outlet>
  </div>
  <the-footer></the-footer>
</div>
